var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconacondominio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.618,
    height: 48.424,
    viewBox: "0 0 37.618 48.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_30",
    "data-name": "Tracciato 30",
    d: "M7.34,35.63H13v9.685H7.34Zm7.187,0h5.658v9.685H14.527ZM3.211,27.525H8.1v4.893H3.211Zm8.1,0h4.893v4.893H11.315Zm8.106,0h4.893v4.893H19.421Zm-16.21-8.1H8.1v4.893H3.211Zm8.1,0h4.893v4.893H11.315Zm8.106,0h4.893v4.893H19.421ZM3.211,11.316H8.1v4.893H3.211Zm8.1,0h4.893v4.893H11.315Zm8.106,0h4.893v4.893H19.421Zm-16.21-8.1H8.1V8.1H3.211Zm8.1,0h4.893V8.1H11.315Zm8.106,0h4.893V8.1H19.421ZM0,0V48.424H27.525l10.093-2.141V9.379L27.525,0Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconacondominio);
export default __webpack_public_path__ + "static/media/iconacondominio.544fe90ee84a9f8f30d2c149c7828180.svg";
export { ForwardRef as ReactComponent };